'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'comet';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e003';
var svgPathData = 'M320 23.7c0-19.7-22.4-31-38.2-19.3 4.7 6.4 4.7 6.4 0 0L81.1 152.2C30.1 189.8 0 249.8 0 313.1 0 422.4 88.6 512 197.9 512 262.1 512 322.2 481 359.3 428.7L500.6 229.9C511.9 214 500.5 192 481 192l-35.1 0 63.4-144.2c1.8-4.1 2.7-8.5 2.7-12.9l0-3c0-17.7-14.3-32-32-32l-3 0c-4.4 0-8.8 .9-12.9 2.7l0 0-144.2 63.4 0-42.5zm-28.7-6.4c5.3-3.9 12.7-.1 12.7 6.4l0 54.7c0 2.7 1.4 5.2 3.6 6.7s5.1 1.7 7.6 .6L470.6 17.4c2-.9 4.2-1.4 6.4-1.4l3 0c8.8 0 16 7.2 16 16l0 3c0 2.2-.5 4.4-1.4 6.4L426.3 196.8c-1.1 2.5-.9 5.3 .6 7.6s4 3.6 6.7 3.6l47.4 0c6.5 0 10.3 7.3 6.5 12.6L346.3 419.4c-34.1 48-89.4 76.6-148.3 76.6-100.4 0-181.9-82.3-181.9-182.9 0-58.3 27.7-113.5 74.6-148L291.3 17.2zM166.8 267.9c5.2-.8 9.7-4 12-8.8L208 200 237.2 259.2c2.3 4.7 6.8 8 12 8.8l65.3 9.5-47.2 46c-3.8 3.7-5.5 9-4.6 14.2l11.2 65-58.4-30.7c-4.7-2.5-10.2-2.5-14.9 0l-58.4 30.7 11.2-65c.9-5.2-.8-10.5-4.6-14.2l-47.2-46 65.3-9.5zm55.6-75c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2l58.4-30.7 58.4 30.7c5.4 2.8 11.9 2.4 16.8-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faComet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;